import { render } from "./VsudDropzone.vue?vue&type=template&id=83af8b66&scoped=true"
import script from "./VsudDropzone.vue?vue&type=script&lang=js"
export * from "./VsudDropzone.vue?vue&type=script&lang=js"

import "./VsudDropzone.vue?vue&type=style&index=0&id=83af8b66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83af8b66"]])

export default __exports__